import { useState, useEffect } from "react";
import api from "../../api.js";
import axios from 'axios';
import ModalTest from "../EditorComponent/EditorComponent.js";
import ConfirmModal from "../ConfirmModal/ConfirmModal.js";
import '../TestDiCarico/TestDiCarico.css';

export default function ProgettiHistory() {
    const [progetti, setProgetti] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [inizialProject, setInizialProject] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [rif, setRif] = useState();
    const [isNewAnalisi, setIsNewAnalisi] = useState(false);
    const [data, setData] = useState({});
    const [filterQuery, setFilterQuery] = useState('');
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    useEffect(() => {
        axios.post(`${api()}/progetti-history/getProgettoHistory`, {}, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then((response) => {
            let projects = response.data || [];
            projects.forEach((element, i) => {
                element.id = i + 1;
            });
            setProgetti(projects);
            setInizialProject(projects);
            setLoading(false);
        })
        .catch((err) => {
            setError(err);
            setLoading(false);
        });
    }, []);

    if (loading) {
        return (
            <div className="progetti-loading">
                <div className="spinner"></div>
                <p>Caricamento storicità progetti in corso...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="progetti-error-box">
                <h3>Si è verificato un errore</h3>
                <p>{error.message}</p>
                <button onClick={() => window.location.reload()} className="btn-retry">Riprova</button>
            </div>
        );
    }

    const requestDelete = (p) => {
        setDeleteTarget({
            id: p.id,
            _id: p._id,
            uni: p.uni,
            name: p.progetto || `Record #${p.id}`
        });
    };

    const confirmDelete = () => {
        if (!deleteTarget) return;
        deleteRow(deleteTarget.id, deleteTarget._id, deleteTarget.uni);
        setDeleteTarget(null);
    };

    const deleteRow = (id, _id, uni) => {
        const progettiCopy = [...progetti];
        const index = progettiCopy.findIndex((progetto) => progetto.id === id);
        if (index !== -1) {
            progettiCopy.splice(index, 1);
            axios.post(`${api()}/progetti-history/deleteProgettoHistory`, {
                id: _id,
                uni: uni,
                headers: {
                    authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then((response) => console.log(response))
            .catch((err) => console.error(err));

            setProgetti(progettiCopy);
            setInizialProject(progettiCopy);
        }
    };

    const addProgetto = () => {
        const progettiCopy = [...progetti];
        const newId = progettiCopy.length > 0 ? Math.max(...progettiCopy.map(p => p.id)) + 1 : 1;
        const newProgetto = {
            id: newId,
            progetto: "Storico Progetto " + newId,
            uni: "hist_" + newId,
            api: 'https://api.example.com/v1/history',
            analisi: 'Snapshot Versione',
            modify: true,
            new: true,
            edit: false
        };
        progettiCopy.unshift(newProgetto);
        setProgetti(progettiCopy);
    };

    const esportTabella = () => {
        const progettiCopy = [...progetti];
        const progettiExport = progettiCopy.map(({ id, progetto, uni, api, analisi }) => ({ id, progetto, uni, api, analisi }));
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(progettiExport, null, 2));
        const downloadAnchor = document.createElement('a');
        downloadAnchor.setAttribute("href", dataStr);
        downloadAnchor.setAttribute("download", `progetti_history_export_${new Date().toISOString().slice(0,10)}.json`);
        document.body.appendChild(downloadAnchor);
        downloadAnchor.click();
        downloadAnchor.remove();
    };

    const changeVal = (id, field, value) => {
        const progettiCopy = [...progetti];
        const index = progettiCopy.findIndex((progetto) => progetto.id === id);
        if (index !== -1) {
            progettiCopy[index][field] = value;
            setProgetti(progettiCopy);
        }
    };

    const modifyRow = (id) => {
        const progettiCopy = [...progetti];
        const index = progettiCopy.findIndex((progetto) => progetto.id === id);
        if (index !== -1) {
            progettiCopy[index].modify = !progettiCopy[index].modify;
            progettiCopy[index].edit = true;
            setProgetti(progettiCopy);
        }
    };

    const saveDataFromApi = (data, path) => {
        axios.post(`${api()}/progetti-history/${path}`, {
            data: data,
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then((response) => {
            setLoading(false);
            setSaveSuccess(true);
            setTimeout(() => setSaveSuccess(false), 3000);
        })
        .catch((err) => {
            console.error(err);
            setError(err);
            setLoading(false);
        });
    };

    const saveProject = () => {
        const progettiCopy = [...progetti];
        const progettiNew = [];
        const progettiModify = [];

        progettiCopy.forEach((p) => {
            if (p.new) {
                const { id, progetto, uni, api, analisi } = p;
                progettiNew.push({ id, progetto, uni, api, analisi });
            } else if (p.edit) {
                const { _id, id, progetto, uni, api, analisi } = p;
                progettiModify.push({ _id, id, progetto, uni, api, analisi });
            }
        });

        if (progettiNew.length > 0) {
            saveDataFromApi(progettiNew, 'createProgettoHistory');
        }
        if (progettiModify.length > 0) {
            saveDataFromApi(progettiModify, 'updateProgettoHistory');
        }
    };

    const filterRow = (value) => {
        setFilterQuery(value);
        const progettiCopy = [...inizialProject];
        if (!value.trim()) {
            setProgetti(progettiCopy);
        } else {
            const q = value.toLowerCase();
            const progettiFilter = progettiCopy.filter((p) => {
                return (
                    (p.id && p.id.toString().includes(q)) ||
                    (p.progetto && p.progetto.toLowerCase().includes(q)) ||
                    (p.uni && p.uni.toLowerCase().includes(q)) ||
                    (p.api && p.api.toLowerCase().includes(q)) ||
                    (p.analisi && p.analisi.toLowerCase().includes(q))
                );
            });
            setProgetti(progettiFilter);
        }
    };

    const funshowModal = () => {
        setShowModal(!showModal);
    };

    const openEditor = (rif, isNew) => {
        if (!isNew) {
            setData({
                "time": new Date().getTime(),
                "blocks": [
                    {
                        "type": "header",
                        "data": {
                            "text": "Report Storico Progetto",
                            "level": 1
                        }
                    }
                ]
            });
            setRif(rif);
            setIsNewAnalisi(isNew);
            funshowModal();
        } else {
            axios.post(`${api()}/editor-history/getDataHistory`, {
                uni: rif,
                headers: {
                    authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then((res) => {
                if (res.data.editorData) {
                    setData({ ...res.data.editorData[0].editor });
                    setRif(rif);
                    setIsNewAnalisi(isNew);
                    funshowModal();
                }
            })
            .catch(() => {
                setRif(rif);
                setIsNewAnalisi(isNew);
                funshowModal();
            });
        }
    };

    return (
        <>
            {!showModal ? (
                <div id="progetti-history" className="progetti-page">
                    <div className="page-header">
                        <div className="header-title">
                            <h1>Progetti History</h1>
                            <span className="count-badge">{progetti.length} Record Storici</span>
                        </div>
                    </div>

                    <div className="progetti-action-bar progetti-cont-btn">
                        <button onClick={addProgetto} className='btn-action primary'>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                            Nuovo Record Storico
                        </button>
                        
                        <button onClick={esportTabella} className='btn-action secondary'>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                            Esporta JSON
                        </button>

                        <button className='btn-action success' onClick={saveProject}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
                            Salva Modifiche
                        </button>

                        <div className="search-box">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                            <input 
                                type="text" 
                                className="find" 
                                placeholder="Filtra cronologia..." 
                                value={filterQuery}
                                onChange={(e) => filterRow(e.target.value)}
                            />
                        </div>
                    </div>

                    {saveSuccess && (
                        <div className="toast-success">
                            ✓ Storico salvato con successo!
                        </div>
                    )}

                    <div className="progetti-table-card">
                        <div className="progetti-table-wrapper">
                            <table className="progetti-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '90px' }}>Modifica</th>
                                        <th style={{ width: '100px' }}>Elimina</th>
                                        <th style={{ width: '50px' }}>ID</th>
                                        <th>Progetto</th>
                                        <th>Nome Univoco</th>
                                        <th>Endpoint API</th>
                                        <th>Analisi / Note Storiche</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {progetti.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="empty-table">Nessun record storico trovato</td>
                                        </tr>
                                    ) : (
                                        progetti.map((p) => (
                                            <tr key={p.id} className={p.modify ? 'row-editing' : ''}>
                                                <td>
                                                    <button 
                                                        onClick={() => modifyRow(p.id)} 
                                                        className={`btn-table-edit ${p.modify ? 'editing' : ''}`}
                                                    >
                                                        {p.modify ? 'Fatto' : 'Edit'}
                                                    </button>
                                                </td>

                                                <td>
                                                    <button onClick={() => requestDelete(p)} className="btn-table-del-btn" title="Elimina Record">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                                        Elimina
                                                    </button>
                                                </td>

                                                <td className="cell-id">#{p.id}</td>

                                                {p.modify ? (
                                                    <>
                                                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'progetto', e.target.value)} value={p.progetto || ''} /></td>
                                                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'uni', e.target.value)} value={p.uni || ''} /></td>
                                                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'api', e.target.value)} value={p.api || ''} /></td>
                                                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'analisi', e.target.value)} value={p.analisi || ''} /></td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td className="cell-title">{p.progetto}</td>
                                                        <td><span className="code-tag">{p.uni}</span></td>
                                                        <td>
                                                            <div 
                                                                className="editor-api-trigger" 
                                                                title="Clicca per aprire l'editor storico"
                                                                onClick={() => openEditor(p.uni, p._id)}
                                                            >
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>
                                                                <span>{p.api}</span>
                                                            </div>
                                                        </td>
                                                        <td className="cell-bold">{p.analisi}</td>
                                                    </>
                                                )}
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <ConfirmModal 
                        isOpen={!!deleteTarget}
                        title="Conferma Eliminazione Record Storico"
                        message={`Sei sicuro di voler eliminare il record storico "${deleteTarget?.name}"?`}
                        onConfirm={confirmDelete}
                        onCancel={() => setDeleteTarget(null)}
                    />
                </div>
            ) : (
                <ModalTest funshowModal={funshowModal} rif={rif} isNewAnalisi={isNewAnalisi} data={data} path={"/editor-history/"} />
            )}
        </>
    );
}

    